import { createBrowserHistory } from 'history';
import store from '../reduxToolkit/store'; // Adjust the import path as necessary
import { RootState } from '../reduxToolkit/rootReducer'; // Adjust the import path as necessary
import UserManagement from '../pages/usermanagement/UserManagement';
import ProcessScheduler from '../pages/data-nexus/projects/ProjectSetup/ProcessScheduler/ProcessScheduler';

// const history = createBrowserHistory();

// const getProjectId = () => {
//   const state = store.getState() as RootState;
//   return state.ProjectModalData.selectedProjectData?.id || 'NONE';
// };

// const customPush = (path: string) => {
//   const projectId = getProjectId();
//   const routeWithProjectId = `${path}/${projectId}`;
//   history.push(routeWithProjectId);
// };

// history.push = customPush;

// history.push = customPush;
export const ROUTE_CONSTANTS = {
  HOME: '/:projectId/home',
  LOGIN: '/login',
  REGISTER_UTILITY: '/registerutility',
  CONNECTIONS: '/:projectId/connections',
  LAYOUT: '/:projectId/',
  USER: '/user',
  TASK: '/task',
  GATEWAY: '/gateway',
  LOGS: '/logs',
  FORM: '/form',
  MASTER: '/:projectId/master',
  ELEMENTS: '/elements',
  ENTITY: '/:projectId/entity',
  Elementsmaster: '/:projectId/elementsmaster',
  TAXONOMY: '/:projectId/taxonomy',
  CONNECTORS: '/:projectId/connectors',
  ApprovalList: '/:projectId/approvalList',
  USERS: '/users',
  MANAGEMENT: '/management',
  Pipelies: '/:projectId/pipelines',
  Profile: '/profile',
  ENTITYREPORTS: '/:projectId/entityreports',
  REPORTS: '/:projectId/reports',
  AUDITLOGS: '/:projectId/auditlogs',
  USERMANAGEMENT: '/:projectId/usermanagement',
  APIBUILDER: '/:projectId/apibuilder',
  APIUSERGUIDE: '/:projectId/apiuserguide',
  sso: '/token',
  ADDNEWTAXONOMY: '/addtaxonomy',
  ADDMASTER: '/:projectId/addmaster',
  PIPELINELOGS: '/pipelineLogs',
  WORKSPACE: '/workspace',
  WORKSPACELIST: '/workspacelist',
  ExistingProjects: '/:projectId/projects',
  NewProjects: '/:projectId/newprojects',
  TENANT: '/:projectId/tenants',
  POWERBIREPORT: '/:projectId/powerbi-report',
  WORKFLOWAPPROVAL: '/:projectId/workflow-approval',
  Dataquality: '/:projectId/v1/Dataquality',
  CONTROL_TOWER: '/:projectId/v2/control-tower',
  Dataprofiler: '/:projectId/v2/Dataprofiler',
  // Dataquality: '/:projectId/v2/Dataquality',
  ExecutionLogs: '/:projectId/v2/Executionlogs',
  DATANEXUSUSERMANAGEMENT: '/:projectId/usermanagement',
  DATANEXUSAPIBUILDER: '/:projectId/api-builder',
  PAIDASHBOARD: '/:projectId/dashboard',
  BIPORTAL: '/:projectId/insights',
  BIPORTALHOME: '/:projectId/bi-home',
  POWERBIBOARD: '/:projectId/bi-dashboard',
  CONTROLBOARD: '/:projectId/control-dashboard',
  PROCESSES: '/:projectId/processes',
  CREATEPROCESS: '/:projectId/create-process',
  AGENTS: '/:projectId/agents',
  AGENTSWELCOME: '/:projectId/agents/welcome',
  AGENTSLIST: '/:projectId/agents/list',
  AGENTSCHAT: '/:projectId/agents/agents-chat',
  AGENTSLOG: '/:projectId/agents-log',
  ADDAGENT: '/:projectId/add-agent',
  ADDNEWAGENT: '/:projectId/agents/add-new-agent',
  EDITAGENT: '/:projectId/add-agent/:id',
  EDITNEWAGENT: '/:projectId/agents/add-new-agent/:id',
  VIEWDETAILS: '/:projectId/view-details',
  ACTIONTAKEN: '/:projectId/action-taken',
  ANALYTICOPTIONS: '/:projectId/analytic-options',
  KPISUMMARY: '/:projectId/kpi-summary',
  DistributorPerformance: '/:projectId/distributor-performance',
  SalesOrgPerformance: '/:projectId/sales-org-performance',
  BRANDPERFORMANCE: '/:projectId/brand-performance',
  FINANCIALPERFORMANCE: '/:projectId/financial-performance',
  APPROVALREQUEST: '/:projectId/approval-request',
  CONFIGURESERVICE: '/:projectId/configureservice',
  Customers: '/:projectId/customers',
  Prompt: '/:projectId/prompt',
  UserManagement: '/:projectId/usermanagement',
  DatabaseConfiguration: '/:projectId/databaseconfiguration',
  ConfigurePolestarModels: '/:projectId/configurepolestarmodels',
  UserList: '/:projectId/userlist',
  RoleList: '/:projectId/rolelist',
  AddRole: '/:projectId/addrole',
  DeDuplication: '/:projectId/data-quality',
  MdmHome: '/:projectId/mdm/home',
  IngestionPipeline: '/:projectId/ingestion',
  Connection: '/:projectId/connection',
  DataModel: '/:projectId/data-model',
  Transformation: '/:projectId/transformation',
  DataLakesetup: '/:projectId/datalake',
  ProcessScheduler: '/:projectId/process-scheduler',
  Enviornment: '/:projectId/enviornment',
  BiPortalSettings: '/:projectId/settings',
  BiPortalAddCanvas: '/:projectId/settings/add-canvas',
  BiPortalEditCanvas: '/:projectId/settings/add-canvas/:canvasID',
  BiPortalPreviewCanvas: '/:projectId/settings/add-canvas/:canvasID/preview',
  BiPortalPreviewCanvasData: '/:projectId/settings/add-canvas/preview/:canvasID',
  // Dataquality: '/:projectId/v2/Dataquality',
  NewUserManagement: '/user-management',
  PowerBiLineage: '/:projectId/powerbi-lineage',
  completeLineage: '/:projectId/lineage/complete',
  ApprovalWorkflow: '/:projectId/approval-workflow',
}
